import { createSlice } from "@reduxjs/toolkit";
import { getBannerList } from "./thunk";

export interface IState {
  lstBanner: any;
  isBannerLoading: boolean;
  isBannerSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  lstBanner: null,
  isBannerLoading: false,
  isBannerSuccess: false,

  error: {},
};

const BannerPositionSlice = createSlice({
  name: "Banner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBannerList.pending, (state: IState, action: any) => {
      state.isBannerLoading = true;
    });
    builder.addCase(
      getBannerList.fulfilled,
      (state: IState, action: any) => {
        state.lstBanner = action.payload.data;
        state.isBannerSuccess = true;
        state.isBannerLoading = false;
      }
    );
    builder.addCase(
      getBannerList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isBannerSuccess = false;
        state.isBannerLoading = false;
      }
    );
  },
});

export default BannerPositionSlice.reducer;
